import './react-routes';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Root } from './Root';
import { loadAnalytics } from './analytics/analytics-bridge';
import { initErrorObservability } from './observability';

// Sem await, no escopo de módulo e antes do createRoot: o SDK carrega em paralelo ao primeiro
// render. A flag não deve depender de uma camada cuja razão de existir é outra, por isso o
// carregamento é chamado aqui e não pela observabilidade.
void loadAnalytics();

// No escopo de módulo, e não num efeito do Root: roda uma vez por carga de página, é imune
// ao duplo render do StrictMode e acontece antes do primeiro render — a janela em que uma
// falha ainda não teria nenhum observador.
initErrorObservability();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
